/**
 * Created by xiajing on 2017/6/1.
 */
import React, { Component } from 'react';
import { Menu } from 'antd';
import './style.scss';
import { withRouter } from 'react-router-dom';
const config = process.env || {};
function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
}

class FunctionMenu extends Component {
    constructor(props) {
        super(props)
    }

    getStatisticsMenus = () => {
        const { currentAgent = {} } = this.props, { tenant = {} } = currentAgent;
        // 公司管理员
        const isCompanyManager = currentAgent?.agentRole?.level === '3';

        return [{
                menuName: '数据导出',
                linkTo: '/statistics/data-export',
                visible: isCompanyManager && tenant.statisticsMenus.includes('dataExport')
            }, {
                menuName: '保单统计',
                linkTo: '/statistics/invoiceStatistics',
                visible: tenant.code !== 19 && tenant.statisticsMenus.includes('invoiceStatistics')
            }, {
                menuName: '业务监控',
                linkTo: '/statistics/business-monitoring',
                visible: isCompanyManager && tenant.statisticsMenus.includes('businessMonitoring')
            }, {
                menuName: '作业监控',
                linkTo: '/statistics/OperationMonitoring',
                visible: isCompanyManager && tenant.statisticsMenus.includes('operationMonitoring')
            }, {
                menuName: '灰名单监控',
                linkTo: '/statistics/gray-list',
                visible: isCompanyManager && tenant.statisticsMenus.includes('grayList')
            }, {
                menuName: '数据监控中心',
                linkTo: '/statistics/data-center',
                redirectUrl: config.domainForIframe + '/map.html',
                visible: tenant.statisticsMenus.includes('dataCenter') && currentAgent.permission.includes('dataCenter')
            }];
    }


    getCenterMenus = () => {
        const { currentAgent = {} } = this.props;
        // 超级管理员
        const isAdmin = currentAgent?.userType === 10;
        // 机构管理员
        const isOrgManager = currentAgent?.agentRole?.level === '2';
        // 公司管理员
        const isCompanyManager = currentAgent?.agentRole?.level === '3';

        return [{
                menuName: '公司管理',
                linkTo: '/setCenter/SetCompany',
                visible: isAdmin
            }, {
                menuName: '机构管理',
                linkTo: '/setCenter/OrgManage',
                visible: isCompanyManager
            }, {
                menuName: '账号管理',
                linkTo: '/setCenter/AccountList',
                visible: true
            }, {
                menuName: '客服组设置',
                linkTo: '/setCenter/AgentGroupSetting',
                visible: true
            }, {
                menuName: '风险规则配置',
                linkTo: '/setCenter/RuleList',
                visible: isCompanyManager && currentAgent?.tenant?.riskContrMod?.riskTypes?.length
            }, {
                menuName: '下次追踪配置',
                linkTo: '/setCenter/TrackSetting',
                visible: isOrgManager
            }, {
                menuName: '我的任务管理',
                linkTo: '/setCenter/MyTaskConfig',
                visible: isOrgManager && currentAgent.tenant.caseTransferMode === 'AUTO'
            }, {
                menuName: '未决追踪配置',
                linkTo: '/setCenter/TrackSwitchConfig',
                visible: isCompanyManager
            }, {
                menuName: '雇主公司管理',
                linkTo: '/setCenter/EmployerCompanyManagement',
                visible: isCompanyManager
            }, {
                menuName: '险种方案管理',
                linkTo: '/setCenter/InsurancePlan',
                visible: isCompanyManager
            }, {
                menuName: '理算规则管理',
                linkTo: '/setCenter/AdjustmentRules',
                visible: isCompanyManager
            }, {
                menuName: '邮件管理',
                linkTo: '/setCenter/EmailManagement',
                visible: isAdmin
            }, {
                menuName: '批量派单规则',
                linkTo: '/setCenter/AssignmentRules',
                visible: isCompanyManager
            }, {
                menuName: '班次管理',
                linkTo: '/setCenter/EmployeeShiftManagement',
                visible: isCompanyManager
            }, {
                menuName: '跨机构派单',
                linkTo: '/setCenter/DispatchOrderManagement',
                visible: isCompanyManager
            }];
    }


    // 处理菜单点击
    clickItem = ({ key }) => {
        console.debug(`点击了${key}`);
        this.props.history.push(key);
    };

    render() {
        const { currentAgent } = this.props;
        let items = [];
        const centerMenus = this.getCenterMenus();

        if (currentAgent && currentAgent.agentRole && currentAgent.agentRole.menus) {
            const statisticsMenus = this.getStatisticsMenus();
            currentAgent.agentRole.menus.map(m => {
                if (m == '100') {
                    items.push(getItem('工作台', 'workbench', null, [
                        getItem(currentAgent.tenant.caseTransferMode === 'MANUAL' ? '工作台' : '我的任务', '/workbench/ReportList', null),
                        getItem(['INJURY_CLAIM','DAMAGE_CAR_LOSS_CLAIM'].some(val => currentAgent.reviewPermission && currentAgent.reviewPermission.includes(val)) ? '案件核赔' : '工作台', '/workBench/ReportCheck', null)
                    ]))
                } else if (m == '200') {
                    items.push(getItem('核心业务', 'customerCenter', null, [
                        getItem('工单列表', '/customerCenter/ReportPage')
                    ]))
                } else if (m == '700') {
                    // medicalAdjustment = (<NavLink to="/medicalAdjustment" activeClassName='focus-bg'>
                    //     <div className="left-info">
                    //         <img src={moneyImg} />
                    //         <span>医疗理算</span>
                    //     </div>
                    // </NavLink>)
                } else if (m == '300') {
                    {
                        /* 登录坐席.agentRole.level === '2' //机构管理员 登录坐席.agentRole.level === '3' //公司管理员 */
                    }
                    items.push(getItem('统计分析', 'statistics', null, statisticsMenus.filter(menu => menu.visible).map(menu => getItem(menu.menuName, menu.linkTo))))
                } else if (m == '500') {
                    items.push(getItem('设置管理', 'setCenter', null, centerMenus.filter(menu => menu.visible).map(menu => getItem(menu.menuName, menu.linkTo))))
                } else if (m == '1000' && currentAgent.tenant.code == 8) {
                    items.push(getItem('票据管理', 'ticket', null, [getItem('发票管理', '/ticket/InvoiceList')]))
                }
            })
            
            const isOrgManager = currentAgent?.agentRole?.level === '2';
            const isCompanyManager = currentAgent?.agentRole?.level === '3';
            const hasClaimCheckPerm = currentAgent.reviewPermission && ['INJURY_CLAIM', 'DAMAGE_CAR_LOSS_CLAIM'].some(val => currentAgent.reviewPermission.includes(val));
            const hasWorkbench = currentAgent.agentRole.menus.includes('100');
            const hasReportCheck = items.some(item => item.children && item.children.some(child => child.key === '/workBench/ReportCheck'));
            
            if (!hasWorkbench && !hasReportCheck && hasClaimCheckPerm && (isOrgManager || isCompanyManager)) {
                items.push(getItem('工作台', 'workbench', null, [
                    getItem('案件核赔', '/workBench/ReportCheck', null)
                ]))
            }
            
            const workbenchIndex = items.findIndex(item => item.key === 'workbench');
            if (workbenchIndex > 0) {
                const workbenchItem = items.splice(workbenchIndex, 1)[0];
                items.unshift(workbenchItem);
            }
        }
        if (currentAgent && currentAgent.userType == 10) {
            items.push(getItem('设置管理', 'setCenter', null, centerMenus.filter(menu => menu.visible).map(menu => getItem(menu.menuName, menu.linkTo))))
        }
        // 新增逻辑，如果用户名为piccadmin,则只保留核心业务菜单
        if (currentAgent.loginName === 'piccadmin') {
            items = items.filter(item => item.key === 'customerCenter');
        }

        return (
            
            <div className="main-menu">
                <Menu onClick={this.clickItem} mode="inline">
                    { items.map(menu => {
                        return <Menu.SubMenu title={menu.label} key={menu.key}>
                            { menu.children.map(child => <Menu.Item key={child.key}>{child.label}</Menu.Item>)}
                        </Menu.SubMenu>
                    })}
                </Menu>
            </div>
        )
    }
}
export default withRouter(FunctionMenu)
